import React from 'react'
import i18n from 'i18next'
import actions from 'redux-auto'
import UserSearchModal from '#components/o/Chat/UserSearchModal'
import Api from '#services/api'

function CreateChatModal() {
  const searchChatParticipant = async userId => {
    try {
      const result = await Api.searchChatParticipant(userId)
      return {
        user: {
          id: result.id,
          info: result.info,
        },
      }
    } catch (e) {
      switch (e.message) {
        case 'api_get_chat_participant_cannot_chat_with_myself':
          return {
            error: {
              message: i18n.t('search_chat_participant_cannot_chat_with_myself'),
              confirmDisabledReason: i18n.t('search_chat_participant_confirm_disabled_reason_cannot_chat_with_myself'),
            },
          }
        case 'api_get_chat_participant_not_found':
          return {
            error: {
              message: i18n.t('search_chat_participant_not_found', [userId]),
              confirmDisabledReason: i18n.t('search_chat_participant_confirm_disabled_reason_not_found'),
            },
          }
        case 'api_get_chat_participant_bad_request':
          return {
            error: {
              message: i18n.t('api_get_chat_participant_bad_request'),
              confirmDisabledReason: i18n.t('api_get_chat_participant_bad_request'),
            },
          }
        default:
          throw e
      }
    }
  }

  const createChat = async userId => {
    try {
      return await Api.createChat({participantId: userId})
    } catch (e) {
      actions.error.writeError({error: e})
      throw new Error(i18n.t(e.message))
    }
  }

  const triggerConfig = {
    testId: 'startChat',
    text: i18n.t('start_chat'),
  }

  const modalConfig = {
    headlineText: i18n.t('start_chat'),
    searchFieldPlaceholder: i18n.t('user_search_field_placeholder'),
    searchResultTitle: i18n.t('user_search_result_found'),
    confirmDisabledReasons: {
      userIdNotValid: i18n.t('search_chat_participant_confirm_disabled_reason_user_id_not_valid'),
      searchInProgress: i18n.t('search_chat_participant_confirm_disabled_reason_search_in_progress'),
      confirmInProgress: i18n.t('search_chat_participant_confirm_disabled_reason_confirm_in_progress'),
    },
    searchCallback: searchChatParticipant,
    confirmCallback: createChat,
  }

  return <UserSearchModal triggerConfig={triggerConfig} modalConfig={modalConfig} />
}

export default CreateChatModal
